export default __webpack_public_path__ + "static/media/gemini.a3773e79.png";